var styles = {
  "PageActions": "Polaris-PageActions"
};

export { styles as default };
